import { forwardRef } from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import globalNavHeight from 'nav-meta/global-nav-height';
import { GRID_BREAKPOINT_SMALL } from 'HubStyleTokens/sizes';
import { JUPITER_LAYER } from 'HubStyleTokens/sizes';
import { STOREFRONT_SEARCH_BAR_CLASS } from './SearchBarInput';
import { jsx as _jsx } from "react/jsx-runtime";
const GLOBAL_NAV_VERTICAL_NAV_WIDTH_FALLBACK = '236px';
const StyledSearchSelectWrapper = styled.div.withConfig({
  displayName: "SearchSelectWrapper__StyledSearchSelectWrapper",
  componentId: "sc-1dhzsk7-0"
})(["z-index:", ";padding-bottom:", "px;&.sticky{position:fixed;top:0;right:0;width:", ";}&.collapsed{height:", ";padding:5px 8px;background-image:linear-gradient( ", ",", ",", " );}.", " input{transition:none;}@media screen and (max-width:", "){padding-bottom:32px;}"], JUPITER_LAYER, props => props.paddingBottom || 40, props => props.isNewAppNav ? `calc(100% - var(--global-nav-vertical-nav-width, ${GLOBAL_NAV_VERTICAL_NAV_WIDTH_FALLBACK}))` : '100%', globalNavHeight, props => props.gradientAngle || '-303deg', props => props.startGradientColor, props => props.endGradientColor, STOREFRONT_SEARCH_BAR_CLASS, GRID_BREAKPOINT_SMALL);
const SearchSelectWrapper = /*#__PURE__*/forwardRef(({
  children,
  collapsed,
  isNewAppNav,
  isSticky,
  gradientAngle,
  startGradientColor,
  paddingBottom,
  endGradientColor
}, ref) => /*#__PURE__*/_jsx(StyledSearchSelectWrapper, {
  ref: ref,
  className: classNames((collapsed || isSticky) && "collapsed", isSticky && "sticky"),
  gradientAngle: gradientAngle,
  isNewAppNav: isNewAppNav,
  startGradientColor: startGradientColor,
  paddingBottom: paddingBottom,
  endGradientColor: endGradientColor,
  children: children
}));
export default SearchSelectWrapper;